





































































import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import { ItemDaVenda, ProdutoProjection, Produto, ProdutoFilho } from '@/models'
import { FindProdutoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import AppLoading from '@/components/ui/AppLoading.vue'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'
import { converterProdutoParaProdutoSimples, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { getRequestError } from '@/helpers/axios-helpers'
import { ConfiguracaoDaConta } from '@/models/ConfiguracaoDaConta'
import DialogoDeAutenticacao from '@/views/application/venda/DialogoDeAutenticacao.vue'
import Confirmacao from '../ui/Confirmacao.vue'


@Component({
	components: {
		AppLoading,
		DialogoDeSelecionarVariante,
		DialogoDeAutenticacao,
	},
})
export default class DialogoDeProdutosComplementares extends Vue {
	@Ref() cards!: { $el: HTMLElement }[]
	@Ref('dialogoDeSelecionarVariante') dialogoDeSelecionarVariante!: any
	@Prop({ type: String, default: 'Venda' }) tipoMovimentacao!: string
	@Prop({ type: Boolean, default: false }) isTelaDeTroca!: boolean
	@Ref() dialogoDeAutenticacao!: DialogoDeAutenticacao
	@Ref('confirmarEstoqueNegativo') confirmarEstoqueNegativo!: Confirmacao

	produtos: ItemDaVenda[] = []
	mostra = false
	buscando = false
	findProdutoUseCase = new FindProdutoUseCase()
	produtosComplementares: ProdutoProjection[] = []
	selecionandoProduto = false
	quantidade = 1
	busca: string | null = null
	configuracaoDeConta: ConfiguracaoDaConta | null = null
	produto: Produto | null = null

	async mostrar(itensDaVenda: ItemDaVenda[]) {
		this.produtos = itensDaVenda
		this.mostra = true
		this.produtosComplementares = []
		await this.buscarProdutosComplementares()
	}

	fechar() {
		this.mostra = false
	}

	async buscarProdutosComplementares() {
		if (!this.produtos || this.produtos.length <= 0) return
		this.buscando = true
		try {
			const idsDosProdutosBase = this.produtos
				.map(item => {
					const produto = item.produto

					if ('idProdutoPai' in produto && produto.idProdutoPai) {
						return produto.idProdutoPai
					}

					return produto.id
				})
				.filter((id, index, self) => id && self.indexOf(id) === index) 

			const params = {
				produtosIds: idsDosProdutosBase,
			}

			this.produtosComplementares = await this.findProdutoUseCase.findProdutosComplementaresByIds(params)
		} catch (error) {
			AlertModule.setError('Erro ao buscar produtos complementares.')
		} finally {
			this.buscando = false
		}
	}

	async selecionarProduto(produtoSelecionado: ProdutoProjection) {
		this.selecionandoProduto = true
		try {
			const produtoCompleto: Produto = await this.findProdutoUseCase.findProdutoById(produtoSelecionado.id)
			if (produtoCompleto.tipo === 'Com Variantes') {
				this.dialogoDeSelecionarVariante && this.dialogoDeSelecionarVariante.abrir(Promise.resolve(produtoCompleto))
			} else {
				this.incluirProdutoNaVenda(produtoCompleto)
			}
		} catch (error) {
			AlertModule.setError('Erro ao buscar detalhes do produto.')
		} finally{
			this.selecionandoProduto = false
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) {
			this.$emit('cancel')
		}
	}

	async incluirProdutoNaVenda(produto: ProdutoFilho | null) {
		if (!produto) return
		const quantidadeDeItens =
				produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT'
					? this.quantidade
					: obterQuantidadePesadaNaBalanca(
						this.busca || '',
						this.configuracaoDeConta?.medida || 6,
						this.configuracaoDeConta?.eans || 7,
						this.configuracaoDeConta?.casasNumericas || 4,
					)
		
		const item: ItemDaVenda = this.criarItemDaVenda(produto, quantidadeDeItens)

		try {
			await this.validarEstoque(produto)

			this.$emit('input', item)
			this.resetarQuantidadeEProduto()

			const podeLiberarEstoque = UserLoginStore.permiteRegraDeNegocio('pode-liberar-produto-sem-estoque')
			if(podeLiberarEstoque){
				item.autenticadoParaLiberarProdutoSemEstoque = true
			}
			this.fechar()
		} catch (error: any) {
			if (getRequestError(error) == 'A quantidade do produto excede o estoque disponível' ||
				getRequestError(error) == `Produtos ${produto.sku} sem quantidade disponível em estoque` ||
				getRequestError(error) == 'Produto não possui estoque parametrizado') {

				if (this.perguntarSeDesejaNegativarEstoque) {
					if (!await VendaModule.chamarConfirmacaoEstoqueNegativo()) {
						this.resetarQuantidadeEProduto()
						return
					}
				}
				AlertModule.setError(error)
				
				const autenticar = await VendaModule.autenticarAcaoTelaDeCaixa({ regra: 'pode-liberar-produto-sem-estoque' })
				this.resetarQuantidadeEProduto()
				if (autenticar) {
					item.autenticadoParaLiberarProdutoSemEstoque = true
					this.$emit('input', item)
					this.fechar()
				} 
			} else if(getRequestError(error) !== 'A quantidade do produto excede o estoque disponível' ||
					getRequestError(error) !== `Produtos ${produto.sku} sem quantidade disponível em estoque`) {
				AlertModule.setError(error)
				this.resetarQuantidadeEProduto()
			} else {
				AlertModule.setError(error)
			}
		}
	}

	validarEstoque(produto: ProdutoFilho | null) {
		if (!produto) return
		const quantidadeDoItem = (VendaModule.vendaAtual?.itens
			.find(item => item.produto.id === produto.id)?.quantidade || 0) +
			this.quantidade
		const podeGerarEstoque = this.$route.fullPath === '/caixa' ?
			VendaModule.lojaDaVenda?.configuracaoDaLoja.podeGerarEstoqueNaVenda :
			VendaModule.lojaDaEntrada?.configuracaoDaLoja.podeGerarEstoqueNaVenda

		const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta
			&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado)
			&& VendaModule.vendaAtual.itens.some(item => item.produto.id === produto.id)

		if (!podeGerarEstoque || this.perguntarSeDesejaNegativarEstoque) {
			if ((!this.podeLiberarProdutoSemEstoque || this.perguntarSeDesejaNegativarEstoque)
			&& !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca) {
				if (VendaModule.lojaDaVenda) {
					const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta 
						&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado) 
						&& VendaModule.vendaAtual.itens.some(item => item.produto.id === produto.id) 

					if(((!podeGerarEstoque || this.perguntarSeDesejaNegativarEstoque) && this.tipoMovimentacao !== 'Entrada' && this.tipoMovimentacao !== 'Balanco') && !this.$route.path.includes('/estoques')) {	
						if((!this.podeLiberarProdutoSemEstoque || this.perguntarSeDesejaNegativarEstoque) && !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca) {
							if(VendaModule.lojaDaVenda) {
								return this.findProdutoUseCase.validarProduto(produto.sku || '', VendaModule.lojaDaVenda.id, quantidadeDoItem, this.perguntarSeDesejaNegativarEstoque)
							} else if (VendaModule.lojaDaEntrada) {
								return this.findProdutoUseCase.validarProduto(produto.sku || '', VendaModule.lojaDaEntrada.id, quantidadeDoItem)
							}
						}
					}}
			}}
	}

	criarItemDaVenda(produto: ProdutoFilho, quantidadeDeItens: number): ItemDaVenda {
		return {
			id: '',
			produto: converterProdutoParaProdutoSimples(produto),
			quantidade: quantidadeDeItens,
			quantidadeLida: 0,
			desconto: { isPercentual: true, valor: 0.0 },
			preco: produto.preco || 0,
			precoDeCusto: 0,
			idConjunto: null,
			descontoVarejo: 0,
			percentualCashback: 0,
			diasParaEfetivarCashback: 0,
			isBrinde: false,
			idItemNotaOrigem: null,
			chaveNotaOrigem: null,
			diasParaExpirarCashback: 0,
			possuiDescontoPorTabela: false,
			valorDescontoRateadoDoItem: 0,
			itemDeDevolucao: false,
			isTotalmenteTrocado: false,
			motivoCancelamento: null,
			isCompra: false,
			idItemOrigem: '',
			isDaVendaReaberta: false,
			vendedor: null,
			autenticadoParaLiberarProdutoSemEstoque: false,
			vendaOrigemDoItem: null,
			valorFreteRateado: 0,
			isItemReferenteATroca: false,
			isDeOutraLoja: false,
			percentualDescontoTabelaPreco: 0,
			precoDeCustoReal: 0,
		}
	}

	resetarQuantidadeEProduto() {
		this.quantidade = 1;
		setTimeout(() => {
			this.produto = null;
		});
	}

	get podeAlterarQuantidadeProduto() {
		return UserLoginStore.permiteRegraDeNegocio(
			'informar-quantidade-de-produtos',
		)
	}

	get podeLiberarProdutoSemEstoque() {
		return UserLoginStore.permiteRegraDeNegocio('pode-liberar-produto-sem-estoque')
	}

	get perguntarSeDesejaNegativarEstoque() {
		return this.$route.fullPath === '/caixa' && VendaModule.lojaDaVenda?.configuracaoDaLoja.permiteConfiguracaoDeNotificacoes
	}
}
